import { InvoiceList } from "./InvoiceList";
import { InvoiceShow } from "./InvoiceShow";

export default {
  list: InvoiceList,
  show: InvoiceShow,
};
